/**
 * PURPOSE: represents the different API types as an enum
 */
export enum MarketplaceTypeEnum {
  DURATION = "DURATION",
  INSTANT = "INSTANT"
}
